import { put, call } from 'redux-saga/effects';
import { productionCreateAPI, productionSearchAPI, productionUpdateAPI, resyncHubStaffDataAPI } from 'src/api/ProductionApi';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import { headerShowAction } from 'src/containers/header-container/actions/HeaderActions';
import { takeFirstSagaUtil } from 'src/utils/ReduxSagaUtils';
import { buildSearchWithNoCase } from 'src/utils/CommonUtils';
import { PRODUCTION_ACTIONS } from '../actions/ProductionActions';
import { toast } from 'react-toastify';

function* search({
    where,whereMySql, currentPage = 0, autopopulate = true, fullTextSearch = true,
} = {}) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(productionSearchAPI, {
            where,
            whereMySql,
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
            currentPage,
            autopopulate,
        });
        yield put({
            type: PRODUCTION_ACTIONS.PRODUCTION_SEARCH_SUCCESS,
            data,
        });

        return data;
    }
    catch (error) {
        console.error('LOG: function*search -> error', error);
        yield put({
            type: PRODUCTION_ACTIONS.PRODUCTION_SEARCH_ERROR,
        });
        return null;
    }
}

function* edit({
    _id,
}) {
    try {
        const {
            data: {
                data: {
                    data,
                },
            },
        } = yield call(productionSearchAPI, {
            where: {
                _id,
            },
            autopopulate: false,
        });

        if (!data || !data[0]) {
            
            yield put(headerShowAction({
                data: 'Unable to Edit, something when wrong',
            }));
        }

        
        yield put({
            type: PRODUCTION_ACTIONS.PRODUCTION_UPSERT_SUCCESS,
            data: data[0],
        });
    }
    catch (error) {
        console.error('LOG: error', error);

        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put(headerShowAction({
            data: error.response.data.data,
        }));
    }
}

function* insert(payload) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(productionCreateAPI, payload);

        yield put(headerShowAction({
            data: 'Created',
        })); 
        toast("Production Created")
        
        yield put({
            type: PRODUCTION_ACTIONS.PRODUCTION_UPSERT_SUCCESS,
            data: {
                ...payload,
                _id: data._id,
            },
        });
        yield put({
            type: PRODUCTION_ACTIONS.PRODUCTION_SEARCH
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: PRODUCTION_ACTIONS.PRODUCTION_UPSERT_ERROR,
        });
    }
}
function* hubStaffSync(payload) {
    try {
         yield call(resyncHubStaffDataAPI, payload);        
        toast("Hub Staff Synced successfully") 
    }
    catch (error) {
        toast.error("Hub Staff Sync Failed. Please connect to system admin or teach support team"); 
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: PRODUCTION_ACTIONS.PRODUCTION_UPSERT_ERROR,
        });
    }
}

function* update(productionId, payload) {
    try {
        yield call(productionUpdateAPI, {
            productionId,
            data: payload,
        });

        yield put(headerShowAction({
            data: 'Updated',
        }));
        if(payload.deleted===true){
            toast("Production deleted")
        }
        else{
            toast("Production updated")
        } 
        
        yield put({
            type: PRODUCTION_ACTIONS.PRODUCTION_SEARCH
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: PRODUCTION_ACTIONS.PRODUCTION_UPSERT_ERROR,
        });
    }
}

function* upsert({
    _id,
    ...payload
}) {
    if (_id) {
        yield update(_id, payload);
    }
    else {
        yield insert(payload);
    }
}

export default [
    takeFirstSagaUtil(PRODUCTION_ACTIONS.PRODUCTION_SEARCH, search),
    takeFirstSagaUtil(PRODUCTION_ACTIONS.PRODUCTION_UPSERT, upsert),
    takeFirstSagaUtil(PRODUCTION_ACTIONS.PRODUCTION_EDIT, edit),
    takeFirstSagaUtil(PRODUCTION_ACTIONS.PRODUCTION_HUBSTAFF_RESYNC, hubStaffSync),
];
